var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagBahrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 75,
    viewBox: "0 0 76 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_727_7556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.75 75C58.4607 75 75.25 58.2107 75.25 37.5C75.25 16.7893 58.4607 0 37.75 0C17.0393 0 0.25 16.7893 0.25 37.5C0.25 58.2107 17.0393 75 37.75 75Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7499 0C30.2241 0 23.2175 2.21851 17.3446 6.03486L26.989 12.4991L14.9238 18.749L26.989 24.9989L14.9238 31.2488L26.989 37.4979L14.9238 43.7477L26.989 49.9975L14.9238 56.2479L26.989 62.4979L17.3435 68.9641C23.2166 72.7812 30.2237 75 37.7499 75C58.4604 75 75.2499 58.2105 75.2499 37.5C75.2499 16.7895 58.4604 0 37.7499 0V0Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_727_7556"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "white",
    transform: "translate(0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagBahrain);
export default __webpack_public_path__ + "static/media/flagBahrain.8d64fded343abbd8547a08b293a494ea.svg";
export { ForwardRef as ReactComponent };